import { render, staticRenderFns } from "./TravelPublish.vue?vue&type=template&id=93c96662&scoped=true"
import script from "./TravelPublish.vue?vue&type=script&lang=js"
export * from "./TravelPublish.vue?vue&type=script&lang=js"
import style0 from "./TravelPublish.vue?vue&type=style&index=0&id=93c96662&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c96662",
  null
  
)

export default component.exports